import {
    GET_MANAGE_USER_DATA_START,
    GET_MANAGE_USER_DATA_SUCCESS,
    GET_MANAGE_USER_DATA_ERROR,
} from "Constant";

const initialState = {
    loading: false,
    data: [],
  };
  
  export default function ManageAccountUserReducer(
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case GET_MANAGE_USER_DATA_START:
        return {
          ...state,
          loading: true,
        };
      case GET_MANAGE_USER_DATA_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case GET_MANAGE_USER_DATA_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
  }
  